import { ArrowDownward, ArrowUpward, Delete, Edit } from '@mui/icons-material';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionsCellRenderer } from '../ActionsCellRenderer/ActionsCellRenderer';

export const StyleTimelineSettingsActionsRenderer = (params: ICellRendererParams) => {
    const { handleChangePrioritization, maxPriority, handleEditRow, showDeleteDialog } = params.context;

    return (
        <ActionsCellRenderer
            actions={[
                {
                    icon: <ArrowUpward />,
                    onClick: () => handleChangePrioritization(params.data.priority, params.data.priority - 1),
                    disabled: params.data.priority === 0,
                },
                {
                    icon: <ArrowDownward />,
                    onClick: () => handleChangePrioritization(params.data.priority, params.data.priority + 1),
                    disabled: params.data.priority === maxPriority,
                },
                {
                    icon: <Edit color="info" />,
                    onClick: () => handleEditRow(params.data),
                },
                {
                    icon: <Delete color="error" />,
                    onClick: () => showDeleteDialog(params.data),
                },
            ]}
        />
    );
};
